module.exports = __webpack_public_path__ + "static/media/left.a12df15b.png";